export default "Wir brauchen Ihre gesamten Buchungsunterlagen. Wie wollen Sie uns diese zukommen lassen?";



// WEBPACK FOOTER //
// ./src/i18n/de/home/steps/1/type/vacation/booked/yes/who-booked/agency/documents/question.js